/* eslint-disable default-case */
import React from 'react';
import './CustomExpand.scss';


const getExpand = (props) => {
  switch (props.expandedName) {
    default: {
      // If expandedRowRender is provided, use it
      if (props.expandedRowRender) {
        return props.expandedRowRender(props.data, props.idx);
      }
      return null;
    }
  }
};

const CustomExpand = (props) => {
  const content = getExpand(props);
  return <section className="expand-container">{content}</section>;
};

export default CustomExpand;

